.container {
    max-width: 400px;
}
